import { clientJson } from './ApiClient';
import { IMeResponse, UserModel } from '../model/UserModel';

const getTabId = () => {
  if (!sessionStorage.tabID) {
    sessionStorage.tabID = Math.random();
  }
  return sessionStorage.tabID;
};

let bc = new BroadcastChannel('user_id');

bc.onmessage = (ev) => {
  if (ev.data !== getTabId()) {
    setTimeout(() => {
      window.location.href = '/';
      window.location.reload();
    }, 100);
  }
};

export interface IAuthenticatedUserProps {
  user: UserModel,
}

export const brodcastUserChange = () => {
  bc.postMessage(getTabId());
};
export const bootstrapAppData = async () => {
  let user = null;
  try {
    user = await getUser();
    if (user) {
      return {
        user: new UserModel(user),
      };
    }
  } catch (e) {
    console.error(e);
  }
  return { user: null };

};
export const apiLocalStorageKey = 'token';
export const getStorageToken = (): string | null => {
  return window.localStorage.getItem(apiLocalStorageKey);
};

export const handleUserResponse = (token: string) => {
  window.localStorage.setItem(apiLocalStorageKey, token);
};

export const getUser = async (): Promise<IMeResponse | null> => {
  let token = getStorageToken();
  if (token) {
    try {
      return await clientJson('user/me') as IMeResponse;
    } catch (error) {
      logout();
      return await Promise.reject(error);
    }
  }
  return null;
};

export interface ILoginProps {
  username: string,
  password: string
}

export const login = async (props: ILoginProps) => {
  await clientJson('auth/login', props);
};

export interface IRegisterProps {
  username: string,
  password: string,
  name: string,
  phone: string,
  website: string
}

export const changeContext = async (id: string) => {
  return clientJson('user/context', { id });
};

export const register = (props: IRegisterProps) => {
  return clientJson('auth/register', props);
};

export const logout = (force = false) => {
  // jak bedziemy recznie robic, to ok, ale jak podczas refresha sie odpali to moze spowoduje ze sie nie odpali :)
  if (force) {
    window.localStorage.removeItem(apiLocalStorageKey);
  } else {
    setTimeout(() => {
      window.localStorage.removeItem(apiLocalStorageKey);
    }, 10);
  }
};

